export default __webpack_public_path__ + "static/media/two.94f0006e.svg";